var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,staticClass:"block w-full",attrs:{"src":_vm.path,"page":i}})}),_vm._v(" "),(this.loading)?_c('div',[_vm._m(0)]):_vm._e()],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fa-2x flex text-gray-500 justify-center"},[_c('i',{staticClass:"fas fa-spinner fa-spin"})])
}]

export { render, staticRenderFns }